import { useCartStore } from '@/modules/cart/store/cart.store'
import { useNotificationStore } from '@/modules/notifications/store/notification.store'

export function clearUserScopedState() {
  const cartStore = useCartStore()
  const notificationStore = useNotificationStore()

  cartStore.clearLocalState()
  notificationStore.$reset()
}
